import React, { ReactElement, useEffect, useState } from "react";
import { useHandleLogout } from "../hooks/useHandleLogout";
import { RoutePaths } from "../enumStrings";
import { Route, Routes } from "react-router-dom";
import { fetchAuthSession } from "aws-amplify/auth";
import { ItemsPurchasableByChamberEnum } from "../graphql/types";
import useGetChamberFromUserIdInAuth from "../hooks/useGetChamberFromUserIdInAuth";
import Error404 from "./pages/ErrorPages/Error404";
import FullPageLoader from "./common/FullPageLoader";
import { useGetLoggedInAppInfo } from "../hooks/useGetLoggedInAppInfo";
import Layout from "./Layout/Layout";
import useScrollToTop from "../hooks/useScrollToTop";

const LogoutManual = (): ReactElement => {
  const handleLogout = useHandleLogout();

  useEffect(() => {
    handleLogout();
    // only run on page load that's why ignoring
    // eslint-disable-next-line
  }, []);

  return <></>;
};

const LogoutForDisabledAdmin = (): ReactElement => {
  const handleLogout = useHandleLogout();

  useEffect(() => {
    const runAtPageLoad = async () => {
      const authSession = await fetchAuthSession();

      if (
        authSession &&
        authSession.tokens &&
        authSession.tokens.accessToken &&
        authSession.tokens.accessToken.payload &&
        authSession.tokens.accessToken.payload["custom:isDisabled"] === "true"
      ) {
        handleLogout();
      }
    };

    runAtPageLoad();

    // only run on page load that's why ignoring
    // eslint-disable-next-line
  }, []);

  return <></>;
};

// const NavigateToSuspensionPageForSuspendedChamberMemberAdmin =
//   (): ReactElement => {
//     const location = useLocation();
//     useEffect(() => {
//       if (location.pathname !== RoutePaths.suspendedChamberMember) {
//         window.location.href = RoutePaths.suspendedChamberMember;
//       }
//     }, [location]);

//     return <></>;
//   };

const LoggedInApp = (): ReactElement => {
  const handleLogout = useHandleLogout();
  const chamberInfo = useGetChamberFromUserIdInAuth();
  const [isLoading, setIsLoading] = useState(true);

  // Scroll to top when switching pages
  useScrollToTop();

  useEffect(() => {
    if (chamberInfo) {
      if (
        !(chamberInfo?.purchasedItems || []).includes(
          ItemsPurchasableByChamberEnum.ChamberMemberPro
        )
      ) {
        handleLogout();
      } else {
        setIsLoading(false);
      }
    }
  }, [chamberInfo, handleLogout]);

  const { userRoutesToShow } = useGetLoggedInAppInfo();

  return (
    <>
      {isLoading ? (
        <FullPageLoader />
      ) : (
        <Layout>
          <LogoutForDisabledAdmin />
          <Routes>
            <Route path={RoutePaths.logout} element={<LogoutManual />} />
            {userRoutesToShow}
            <Route path="*" element={<Error404 />} />
          </Routes>
        </Layout>
      )}
    </>
  );
};

export default LoggedInApp;
